import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  OptionType,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollectionOrderState,
  FieldSelectCollector,
  FieldSelectNomos,
  FieldSelectRegion,
} from 'shared-pages';
import { useField } from 'formik';
import {
  isAfisCyprus,
  isMedicycle,
  isRebatteryLiion,
  isFotokiklosi,
} from 'shared-pages/common/constants';
import { useRootStore } from 'store';
import { FieldSelectCollectionOrderState2 } from 'shared-pages/components/field-select/fs-collection-order-state2';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};

  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { code: likeObj },
          { '$collectionpoint.name$': likeObj },
          { '$collectionpoint.addressCity$': likeObj },
          { '$collectionpoint.addressArea$': likeObj },
        ],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'orderedDate'),
      };
    }
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.wasteOriginTypeId) {
      where = { ...where, wasteOriginTypeId: values.wasteOriginTypeId };
    }

    if (values.wasteDestinationTypeId) {
      where = { ...where, wasteDestinationTypeId: values.wasteDestinationTypeId };
    }

    if (values.addressNomos) {
      where = { ...where, addressNomos: values.addressNomos };
    }
    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }

    if (values.statusId && Array.isArray(values.statusId) && values.statusId.length > 0) {
      const statusIds = values.statusId.map((v) => v);
      where = { ...where, statusId: statusIds };
    }
    if (values.isUrgent !== undefined && values.isUrgent !== null && values.isUrgent !== '') {
      where = { ...where, isUrgent: values.isUrgent };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { authStore, appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);

      onChange({ ...values });
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    collectorId: initialValues?.collectorId ?? undefined,
    isActive: initialValues?.isActive ?? null,
    regionId: initialValues?.regionId ?? undefined,
    wasteOriginTypeId: initialValues?.wasteOriginTypeId ?? undefined,
    wasteDestinationTypeId: initialValues?.wasteDestinationTypeId ?? undefined,
    addressNomos: initialValues?.addressNomos ?? undefined,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    statusId: initialValues?.statusId ?? [],
    isUrgent: initialValues?.isUrgent ?? undefined,
  };
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (κωδικός,σημείο συλλογής, πόλη, περιοχή)')}
          type="search"
          disable={disable}
        />
        <FormCol>
          {isRebatteryLiion || isFotokiklosi ? (
            <FieldSelectCollectionOrderState2
              label={'Κατάσταση Αιτήματος Συλλογής'}
              isMulti={true}
            />
          ) : (
            <FieldSelectCollectionOrderState label={'Κατάσταση Αιτήματος Συλλογής'} />
          )}
        </FormCol>
        {appStore.isPlatformOwner && <FieldSelectCollector as={FormCol} />}
        <FieldSelectIsActive label={t('Επείγει')} name="isUrgent" disable={disable} />

        <FieldDateRanger as={FormCol} label="Υποβολή από" name="startDate" name2="endDate" />
        <FieldSelectRegion as={FormCol} />
        {!(isAfisCyprus || isMedicycle) && <FieldSelectNomos as={FormCol} />}
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
